import { ChangeDetectionStrategy, Component, ElementRef, Renderer2, ViewChild, ViewEncapsulation } from "@angular/core";
import { NzTableFixedRowComponent } from "ng-zorro-antd/table";
import { UiTableStyleService } from "@webapp/ui/table/services/table-style.service";

@Component({
  selector: "tr[ui-table-fixed-row], tr[uiExpand]",
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: "table-fixed-row.component.html",
})
export class UiTableFixedRowComponent extends NzTableFixedRowComponent {
  @ViewChild("tdElement", { static: true }) public tdElement!: ElementRef;

  constructor(uiTableStyleService: UiTableStyleService, renderer: Renderer2) {
    super(uiTableStyleService, renderer);
  }
}
